



// -------------------------------------------------------
// --------------------- Side menu -----------------------
// -------------------------------------------------------
class MenuSlide extends Backbone.View {

    get el() {
        return 'body';
    };

    get events() {
        return {
            'click #start_create_button': 'toggle_menu',
            'click .button-nav.menu': 'toggle_menu',
            'click .register-signin': 'close_menu',
            'swipeleft #side_menu': 'close_menu',
            'tap .content-mask': 'close_menu_prevent_default',
            'click .content-mask': 'close_menu_prevent_default',
            'swipeleft .content-mask': 'close_menu'
        };
    };

    toggle_menu () {
        this.$el.toggleClass('side-menu-active');
    };

    close_menu () {
        this.$el.removeClass('side-menu-active');
    };

    close_menu_prevent_default (e) {
        e.preventDefault();

        this.close_menu();
    };

};

class NavAccordionToggle extends Backbone.View {
    get el() {
        return '.accordion-nav';
    };

    get events() {
        return {
            'click': 'toggle_accordion'
        };
    };

    toggle_accordion (e) {
        e.preventDefault();
        var header = $(e.target).closest('.accordion-nav');
        var currentActive = $('.ui-accordion').not('.collapsed');

        if (header.parent('div').hasClass('collapsed')) {
            $(currentActive).children('ul').slideUp('fast', function () {
                $(currentActive).children('.accordion-nav').addClass('inactive');
                $(currentActive).addClass('collapsed');
            });
            $(header.parent('div').children('ul')).slideDown('fast', function () {
                header.parent('div').removeClass('collapsed');
                header.removeClass('inactive');
            });
        };
    };

};


$(function() {
    window.menu_slide = new MenuSlide();
    window.nav_accordion_toggle = new NavAccordionToggle();
});



// WEBPACK FOOTER //
// ./assets/es6/common/side_menu.es6